export default __webpack_public_path__ + "static/canada-9604cd042c8b61c4f3a5fabcacf25f3d.svg";